import { Link } from 'react-router-dom'
import { findTerm } from '../lib/glossary'

interface Props {
  id: string
  children?: React.ReactNode
}

export function Term({ id, children }: Props) {
  const entry = findTerm(id)
  if (!entry) {
    return <span>{children}</span>
  }
  const label = children ?? entry.term
  return (
    <Link
      to={`/hakkinda#${id}`}
      title={entry.short}
      className="text-text underline decoration-dotted decoration-text-dim/60 underline-offset-2 hover:decoration-accent hover:text-accent"
    >
      {label}
    </Link>
  )
}
